<h2 mat-dialog-title>Access Log Details</h2>
    <mat-dialog-content>
      <div *ngIf="data.accessLogData">
      
        <div class="info-row">
  <span class="label">Module</span>
  <span class="colon">:</span>
  <span class="value">{{ data.accessLogData.parent || 'Menu' }}</span>
</div>
<div class="info-row">
  <span class="label">Function</span>
  <span class="colon">:</span>
  <span class="value">{{ data.accessLogData.function_name }}</span>
</div>
<div class="info-row">
  <span class="label">User</span>
  <span class="colon">:</span>
  <span class="value">{{ data.accessLogData.user_name }}</span>
</div>
<div class="info-row">
  <span class="label">Station</span>
  <span class="colon">:</span>
  <span class="value">{{  data.accessLogData.station_name  }}</span>
</div>
<div class="info-row">
  <span class="label">Time</span>
  <span class="colon">:</span>
  <span class="value">{{ data.accessLogData.access_time | date: 'dd-MM-yyyy hh:mm a' }}</span>
</div>

        <div class="data-container" *ngIf="formattedData">
         <h2>Additional info</h2>
  <pre class="json-display">{{ formattedData }}</pre>
        </div>
    
      
        <!-- Add more fields as needed -->
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="mdc-action-container">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>